// removed by extract-text-webpack-plugin
module.exports = {"container":"QuestionDefinitionsList__container___nPqEP","header":"QuestionDefinitionsList__header___3Ucm5"};